import { getContext } from '@/context';
import { MINIAPP_PACKAGE_ID } from '@/consts/configs';
import ANALYTICS_EVENT_NAMES from '@/consts/analytics';

/**
 * Sends an object_export analytics event.
 * Fires when user downloads the result.
 */
const sendObjectExportAnalytics = () => {
  try {
    const params = {
      source: MINIAPP_PACKAGE_ID,
    };

    getContext().handlers.sendAnalytics({
      eventName: ANALYTICS_EVENT_NAMES.OBJECT_EXPORT,
      params,
    });
  } catch {
    // Failed to send analytics
  }
};

export default sendObjectExportAnalytics;
